module.exports = __webpack_public_path__ + "03_medium_brown.ee727e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_medium_brown.png
// module id = 71cH
// module chunks = 0